"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importDefault(require("styled-components"));
var clsx_1 = __importDefault(require("clsx"));
var Polished_1 = require("../utils/Polished");
var reactHelpers_1 = require("../utils/helpers/reactHelpers");
var TagSC = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  user-select: none;\n  outline: 0;\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ._ndsTag__icon {\n    margin-right: ", ";\n    flex: none;\n    fill: ", ";\n  }\n\n  height: ", ";\n  border-radius: ", ";\n  padding: ", " ", ";\n\n  &._ndsTag--large {\n    height: ", ";\n    border-radius: ", ";\n    padding: ", " ", ";\n  }\n\n  color: ", ";\n  background-color: ", ";\n  border: ", " solid\n    ", ";\n\n  &._ndsTag--contained {\n    color: ", ";\n    background-color: ", ";\n\n    ._ndsTag__icon {\n      fill: ", ";\n    }\n  }\n"], ["\n  user-select: none;\n  outline: 0;\n\n  font-family: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  font-weight: ", ";\n  white-space: nowrap;\n\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n\n  ._ndsTag__icon {\n    margin-right: ", ";\n    flex: none;\n    fill: ", ";\n  }\n\n  height: ", ";\n  border-radius: ", ";\n  padding: ", " ", ";\n\n  &._ndsTag--large {\n    height: ", ";\n    border-radius: ", ";\n    padding: ", " ", ";\n  }\n\n  color: ", ";\n  background-color: ", ";\n  border: ", " solid\n    ", ";\n\n  &._ndsTag--contained {\n    color: ", ";\n    background-color: ", ";\n\n    ._ndsTag__icon {\n      fill: ", ";\n    }\n  }\n"])), function (p) { return p.theme.FontFamilyBase; }, function (p) { return p.theme.SizeFontTagBase; }, function (p) { return p.theme.SizeLineHeightTagBase; }, function (p) { return p.theme.ContentFontWeightTagBase; }, Polished_1.rem('4px'), function (p) { return p.color; }, function (p) { return p.theme.SizeHeightTagMedium; }, function (p) { return p.theme.SizeBorderRadiusTagMedium; }, Polished_1.rem('4px'), Polished_1.rem('8px'), function (p) { return p.theme.SizeHeightTagLarge; }, function (p) { return p.theme.SizeBorderRadiusTagLarge; }, Polished_1.rem('8px'), Polished_1.rem('12px'), function (p) { return p.color; }, function (p) { return p.theme.ColorBackgroundTagOutlinedBase; }, function (p) { return p.theme.SizeBorderWidthDefault; }, function (p) { return p.color; }, function (p) { return p.theme.ColorFontTagContainedBase; }, function (p) { return p.color; }, function (p) { return p.theme.ColorFontTagContainedBase; });
var Tag = function (props) {
    var label = props.label, variant = props.variant, size = props.size, icon = props.icon, color = props.color, forwardedRef = props.forwardedRef, classNameProp = props.className, others = __rest(props, ["label", "variant", "size", "icon", "color", "forwardedRef", "className"]);
    var classes = clsx_1.default({ '_ndsTag--contained': variant === 'contained' }, { '_ndsTag--large': size === 'l' }, classNameProp);
    var iconComp = null;
    if (icon && react_1.default.isValidElement(icon)) {
        iconComp = react_1.default.cloneElement(icon, {
            className: clsx_1.default('_ndsTag__icon', icon.props && icon.props.className),
            size: 's'
        });
    }
    return (react_1.default.createElement(TagSC, __assign({ ref: forwardedRef, className: classes, color: color }, others),
        iconComp,
        react_1.default.createElement("span", { className: "_ndsTag__label" }, label)));
};
exports.TagRootComp = Tag;
Tag.propTypes = {
    label: prop_types_1.default.oneOfType([
        prop_types_1.default.arrayOf(prop_types_1.default.node),
        prop_types_1.default.node,
        prop_types_1.default.string
    ]).isRequired,
    variant: prop_types_1.default.oneOf(['outlined', 'contained']),
    size: prop_types_1.default.oneOf(['m', 'l']),
    icon: prop_types_1.default.element,
    color: prop_types_1.default.string,
    className: prop_types_1.default.string,
    forwardedRef: prop_types_1.default.any
};
Tag.defaultProps = {
    variant: 'outlined',
    size: 'm',
    icon: undefined,
    color: '#666666',
    className: undefined,
    forwardedRef: null
};
exports.default = reactHelpers_1.withForwardedRef(Tag);
var templateObject_1;
//# sourceMappingURL=Tag.js.map